<template>
  <ul v-if="serviceList.length" class="service-info-wrapper clearfix">
    <li
      v-for="(item, serviceKey) in serviceList"
      :key="serviceKey"
      class="service-item"
    >
      <span v-if="serviceKey > 0" class="service-railing"></span>
      <div
        :class="[
          'service-content',
          { disabled: disabled, maxW: item.type === 'fee' },
        ]"
        @click="serviceClick(item)"
      >
        <p class="title" @click.stop="show(item)">
          <RichText :text="item.title" is-argb />
          <template v-if="item?.rules?.text">
            <i ref="titleIcon" class="icon-v3_outlined_information"></i>
            <rich-tip
              :ref="`tip${item.type}`"
              direction="top"
              effect="light"
              offset-left="30px"
              style="margin-top: 8px; margin-right: 16px"
              >{{ item?.rules?.text }}</rich-tip
            >
          </template>
        </p>
        <div
          v-if="item.contentListFE && item.contentListFE.length"
          class="rich-text-list-box"
        >
          <RichText
            v-for="(item, index) in item.contentListFE"
            :key="index"
            class="rich-text text-list-item"
            :class="item.class || ''"
            :type="item.type"
            is-argb
            :text="item.content"
          />
        </div>
        <RichText v-else class="rich-text" :text="item.content" />
      </div>
    </li>
  </ul>
</template>

<script>
import RichText from '@/components/RichText/index.vue';

export default {
  name: 'ShopTopService',
  components: {
    RichText,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    serviceList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      offsetRight: '',
    };
  },
  computed: {},
  mounted() {
    this.init();
  },
  methods: {
    init() {},
    show(item) {
      if (!item?.rules?.text) return;
      this.$refs[`tip${item.type}`]?.show();
    },
    serviceClick(item) {
      this.$emit('serviceClick', item);
    },
  },
};
</script>
<style lang="scss">
.service-content {
  .rich-tip {
    max-width: rem(600);
    padding: rem(32) rem(80) rem(32) rem(40);
    box-shadow: 0px -5px 40px 0px rgba(0, 0, 0, 0.08);
    border-radius: rem(20);
    transition: none;
    animation: none;
    .rich-tip-close {
      right: rem(20);
      top: rem(10);
      font-size: rem(36);
    }
    .tip-content {
      white-space: pre-line;
    }
  }
}
</style>
<style lang="scss" scoped>
.service-info-wrapper {
  display: flex;
  .service-item {
    flex-shrink: 0;
    overflow: hidden;
    &:last-child {
      flex: 1;
      display: flex;
    }
  }
  .service-railing {
    flex-shrink: 0;
    display: block;
    margin: rem(5) rem(48);
    width: 0;
    height: rem(56);
    @include thinBorder(left, rgba(0, 0, 0, 0.1));
  }
}
.service-content {
  overflow: hidden;
  .title {
    margin-bottom: rem(4);
    line-height: rem(28);
    font-size: rem(24);
    color: rgba(0, 0, 0, 0.6);
    font-family: DiDiSans-Pro-Regular;
    font-weight: 400;
    display: flex;
    span,
    i {
      display: inline-block;
      vertical-align: middle;
    }
    i {
      margin-left: rem(4);
    }
    span {
      display: inline-block;
      max-width: rem(160);
      @include ellipsis();
    }
  }
  .rich-text-list-box {
    display: flex;
    align-items: center;
    .font-bold {
      font-family: DiDiSans-Pro-Bold;
      font-size: rem(28);
    }
    .ori-price-info {
      font-size: rem(22);
      // text-decoration: line-through;
      position: relative;
      top: rem(3);
    }
    .surge-info {
      font-size: rem(24);
    }
    .threshold-info {
      font-size: rem(22);
      position: relative;
      top: rem(3);
    }
  }
  .rich-text {
    float: left;
    font-size: rem(24);
    font-family: DiDiSans-Pro-Regular;
  }
  .text-list-item {
    &.margin-r-4 {
      margin-right: rem(4);
    }
    &.margin-r-8 {
      margin-right: rem(8);
    }
    &.margin-l-4 {
      margin-left: rem(4);
    }
    &.margin-l-8 {
      margin-left: rem(8);
    }
  }
  .text-list-item:first-child {
    font-size: rem(28);
  }
  .text-list-item:last-child {
    // max-width: rem(230);
    @include ellipsis();
  }
  &.disabled {
    .title {
      float: left;
      margin-bottom: 0;
      margin-right: rem(9);
    }
  }
  &.maxW {
    max-width: rem(420);
    .title span {
      max-width: 80%;
    }
    .text-list-item:last-child {
      max-width: 100%;
    }
  }
}
</style>
